const contactInfo = [
  {
    icon: 'ri-map-pin-line',
    label: 'Office Address',
    value: '28972 US-281 Suite 107\nBulverde, TX 78163',
  },
  {
    icon: 'ri-phone-line',
    label: 'Phone',
    value: '+1 (708) 897-4646',
  },
  {
    icon: 'ri-mail-line',
    label: 'Email',
    value: 'info@dascleaning.com',
  },
  {
    icon: 'ri-time-line',
    label: 'Business Hours',
    value: 'Mon–Fri: 7:00 AM – 7:00 PM\nSat: 8:00 AM – 4:00 PM',
  },
];

export default function Contact() {
  return (
    <section id="contact" className="py-20 md:py-28 bg-[#f8f9f7]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <span
            className="text-[#4caf7d] text-xs font-semibold tracking-widest uppercase"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Get In Touch
          </span>
          <h2
            className="text-3xl md:text-5xl font-bold text-[#1a3a2a] mt-2"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            We&apos;d Love to Hear<br />From You
          </h2>
        </div>

        <div className="flex justify-center">
          {/* Contact Info */}
          <div className="flex flex-col gap-6 max-w-lg w-full">
            {contactInfo.map((item) => (
              <div key={item.label} className="flex gap-4 items-center">
                <div className="w-11 h-11 flex items-center justify-center bg-[#e8f5ee] rounded-xl flex-shrink-0">
                  <i className={`${item.icon} text-[#4caf7d] text-lg`}></i>
                </div>
                <div>
                  <div className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-0.5">
                    {item.label}
                  </div>
                  <div className="text-sm text-[#1a3a2a] font-medium whitespace-pre-line leading-relaxed">
                    {item.value}
                  </div>
                </div>
              </div>
            ))}

            {/* Social Links */}
            <div className="mt-4 flex flex-col items-center">
              <div className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-3">Follow Us</div>
              <div className="flex gap-3 justify-center">
                {[
                  { icon: 'ri-linkedin-fill', label: 'LinkedIn' },
                  { icon: 'ri-facebook-fill', label: 'Facebook' },
                  { icon: 'ri-instagram-line', label: 'Instagram' },
                  { icon: 'ri-twitter-x-line', label: 'Twitter' },
                ].map((s) => (
                  <a
                    key={s.label}
                    href="#"
                    rel="nofollow"
                    aria-label={s.label}
                    className="w-10 h-10 flex items-center justify-center bg-[#1a3a2a] text-white rounded-full hover:bg-[#4caf7d] transition-colors duration-200 cursor-pointer"
                  >
                    <i className={`${s.icon} text-sm`}></i>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
